/** Get employee suggestions */
const apiGetEmployeeSuggestions = bookId => {
  return `/api/authors/?book_id=${bookId}`;
};
/** Get employee types */


const apiGetEmployeeTypes = "/api/authors/types/";
export { apiGetEmployeeSuggestions, apiGetEmployeeTypes };